// @flow
import React from 'react';
import type { EventPreviewType } from 'types/Event';
import RowEvent from 'components/event/RowEvent';
import TopEvent from 'components/event/TopEvent';
import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';
import { handleTagEvent }from 'utils/tagManagerUtils';

export type Props = {
  events: Array<EventPreviewType>,
  highlightFirst?: boolean,
  sidebar?: boolean,
  limit?: number
};

function renderRowEvents(events: Array<EventPreviewType>) {
  return events.map((e, index) => <RowEvent key={index} event={e} />);
}

const EventsCard = (props: Props) => {
  const { sidebar } = props;

  const classNamesContainer = dynamicClassName('box ');
  sidebar ? classNamesContainer.add('mb-4 mb-md-5') : classNamesContainer.add('event');
  const limit = props.limit || 3;
  return (
    <div className={classNamesContainer.build()}>
      {props.highlightFirst && props.events.length > 0 && <TopEvent event={props.events[0]} />}
      {renderRowEvents(props.highlightFirst ? props.events.slice(1, limit) || [] : props.events.slice(0, limit))}
      <Link
        to={{
          pathname: `/evenements`
        }}
        role="button"
        tabIndex={0}
        className="link-chevron link-chevron--block"
        data-label=""
        onClick={handleTagEvent('module evenement', `clic decouvrir les evenements`, window.location.pathname)}
      >
        <span>Découvrir les événements</span>
        <i className="icon icon-chevron-right" />
      </Link>
    </div>
  );
};

export default EventsCard;
